import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { IconModule } from '@shared/components/icon';

import { ButtonComponent } from './button.component';

@NgModule({
  exports: [ButtonComponent],
  imports: [CommonModule, IconModule, ButtonComponent],
})
export class ButtonModule {}
